module.exports = __webpack_public_path__ + "img/bl3fl02_center_002.b684796b.png";